import { render, staticRenderFns } from "./ImportarFuncionarios.vue?vue&type=template&id=70dc3b7a&"
import script from "./ImportarFuncionarios.vue?vue&type=script&lang=js&"
export * from "./ImportarFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports